module.exports = __webpack_public_path__ + "f1a65fdeb3a8ed438674afdfd4d1848e.png";